import React, { useState, useEffect, useRef } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useQuery } from "react-query";
import useApi from "../../hooks/useApi";
import AddPolicyItem from "./AddPolicyItem";
import moment from "moment";
import Swal from "sweetalert2";
import usePagination from "../../hooks/usePagination";
import useReload from "../../hooks/useReload";
import { FilterBar, NavigateBackButton } from "../../widgets";
import PolicyItemStatus, { activeStatus } from "../../widgets/PolicyItemStatus";
import useSortableTableHeader from "../../hooks/useSortableTableHeader";

const PolicyItemList = (props) => {
  // const { searchParamString } = props;
  const { scope } = props;
  const { reload, toggleReload } = useReload();
  const { api, auth } = useApi();
  const { searchParamString } = usePagination();
  const { id = "" } = useParams();
  const [showUnderwrite, setShowUnderwrite] = useState(
    scope === "item" ? true : false
  );
  const { TableHeader } = useSortableTableHeader();

  const removePolicy = async (policyItemId = null) => {
    const callRemove = async () => {
      try {
        if (policyItemId) {
          const response = await api.delete(
            `/policies/policy-items/${policyItemId}`
          );
          if (response) {
            Swal.fire("Deleted!", `Policy removed`, "success");
            toggleReload();
          } else {
            Swal.fire("Delete failed!", `Policy not provided`, "info");
          }
        } else {
          Swal.fire("Delete failed!", `Policy not provided`, "error");
        }
      } catch (error) {
        // console.error(error);
        Swal.fire(
          "Error",
          `Failed to remove policy - ${error.message}`,
          "error"
        );
      }
    };
    Swal.fire({
      title: "Remove Policy Item?",
      text: "Do you want to continue",
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        callRemove();
      }
    });
  };

  const getPolicies = async (searchString) => {
    // console.log(searchParamString);
    try {
      const url = `/policies/${props?.items?.id}/policy-items${searchString}`;
      const { data } = await api.list(url);
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: policyItems, refetch } = useQuery(
    ["policyItems", searchParamString, auth, props],
    ({ queryKey }) => getPolicies(queryKey[1])
  );

  const { allowAdd = true } = props;

  const headers = [
    { label: "Company", sort: true, field: "Company.name" },
    { label: "Created", sort: true, field: "createdAt" },
    { label: "Info", sort: true, field: "title" },
    { label: "Expires", sort: true },
    { label: "Status", className: "text-center", sort: true },
    { label: "" },
  ];

  return (
    <>
      <div className="d-md-flex align-items-baseline mt-3">
        {allowAdd && <AddPolicyItem />}
        <FilterBar />
      </div>
      <div className="table-responsive bg-white mb-3">
        <table className="table table-striped">
          <TableHeader items={headers} />
          <tbody>
            {policyItems &&
              policyItems?.map((policy) => (
                <tr key={policy.id}>
                  <td>
                    {policy?.Company?.name && (
                      <>
                        <span>{policy.Company.name}</span> <br />
                      </>
                    )}
                    {policy?.Branch?.name && (
                      <>
                        <span>{policy?.Branch?.name}</span>
                        <br />
                      </>
                    )}
                    <span>
                      {policy?.PolicyType?.name} - {policy?.Product?.name}
                    </span>
                  </td>
                  <td>{moment(policy.createdAt).format("DD/MM/YYYY")}</td>
                  <td>
                    {policy?.title && (
                      <>
                        <span className="text-muted">{policy?.title}</span>
                        <br />
                      </>
                    )}

                    {policy?.policyNumber && (
                      <span className="text-primary">
                        {policy?.policyNumber}
                      </span>
                    )}
                    <br />
                    {policy?.premium && (
                      <span className="fw-bold text-info">
                        Premium:{policy.policyCurrency}{" "}
                        {Number(policy.premium).toLocaleString("en-US")}
                      </span>
                    )}
                  </td>
                  <td>
                    {activeStatus.includes(policy.status) && (
                      <>
                        <span>
                          {moment(policy?.expires).format("DD/MM/YYYY") || ""}
                        </span>
                        <p className="text-muted">
                          {policy?.expires &&
                            moment().to(moment(policy?.expires))}
                        </p>
                      </>
                    )}
                  </td>
                  <td className="text-center fs-5">
                    <PolicyItemStatus status={policy.status} />
                  </td>
                  <td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center">
                      <div className="btn-group">
                        <button
                          onClick={() => removePolicy(policy.id)}
                          title="delete record"
                          type="button"
                          className={
                            activeStatus.includes(policy.status)
                              ? "btn btn-icon btn-outline-primary disabled"
                              : "btn btn-icon btn-outline-primary"
                          }
                        >
                          <i className="bi bi-trash-fill fs-4 text-default"></i>
                        </button>
                        {/* {policy.canUnderwrite && ( */}
                        <Link
                          to={`item/${policy.id}`}
                          title="View policy"
                          className="btn btn-icon btn-outline-primary"
                        >
                          <i className="bi bi-pencil-square fs-4 text-success"></i>
                        </Link>
                        {/* )} */}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export { PolicyItemList };
